export const makeQuantityPositive = (quantity) => {
  // Check if quantity is negative
  if (quantity < 0) {
    // Make quantity positive
    return -quantity;
  }
  // If quantity is already positive, return it as is
  return quantity;
};
